/** Created by azhou on 2018/7/10.*/
<template>
  <div>
    <!--标题部分-->
    <public-title>广告位管理</public-title>
    <div class="bg-white p-5 load-area">
      <el-tabs v-model="activeName">
        <el-tab-pane label="PC端" name="1" /><el-tab-pane label="手机端" name="2" />
      </el-tabs>
      <ul class="list-head mt-3">
        <li class="w-50" v-for="item in titleArr" :key="item">{{item}}</li>
      </ul>
      <ul class="list-item" v-for="(item,index) in advertiseLists" :key="item.title">
        <li class="w-50 list-item-col">{{index+1}}</li>
        <li class="w-50 list-item-col">{{item.title}}</li>
        <li class="w-50 list-item-col">{{item.price}}</li>
        <li class="w-50 list-item-col">{{item.position}}</li>
        <li class="w-50 list-item-col-end"><span class="text-link" @click="editItem(item)">编辑</span></li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        activeName: '1',
        titleArr:['编号','标题','价格','位置','操作'],
        firstArr:[
          {title:'首页-滚屏',price:'100.00',position:'首页',indexId:1},
          {title:'首页-推荐酒店-滚屏',price:'50.00',position:'首页',indexId:2},
          {title:'首页-推荐酒店-其他',price:'120.00',position:'首页',indexId:3},
          {title:'首页-推荐民宿',price:'120.00',position:'首页',indexId:7},
          {title:'首页-合作酒店',price:'120.00',position:'首页',indexId:4},
          {title:'酒店列表页-右侧广告',price:'120.00',position:'酒店列表页',indexId:5},
          {title:'民宿列表页-右侧广告',price:'120.00',position:'民宿列表页',indexId:8},
          {title:'民宿列表页-热门民宿',price:'120.00',position:'民宿列表页',indexId:9},
          {title:'首页-推荐景区',price:'120.00',position:'首页',indexId:10},
          {title:'景区列表页-右侧广告',price:'120.00',position:'景区列表页',indexId:11},
          {title:'景区列表页-热门景区',price:'120.00',position:'景区列表页',indexId:12},
        ],
        secondArr:[
          {title:'首页-滚屏',price:'100.00',position:'首页',indexId:1},
          {title:'首页-推荐酒店',price:'100.00',position:'首页',indexId:2},
          {title:'首页-推荐民宿',price:'100.00',position:'首页',indexId:7},
          {title:'首页-推荐景区',price:'100.00',position:'首页',indexId:10},
          {title:'首页-推荐度假产品',price:'100.00',position:'首页',indexId:13},
          {title:'首页-合作酒店',price:'100.00',position:'首页',indexId:4},
        ],
        advertiseLists:[]
      }
    },
    mounted() {
      if(this.$route.query.type){
        this.activeName=this.$route.query.type;
      }
      console.log(      );
    },
    watch: {
      activeName(newVal) {
        if (newVal === '1') this.advertiseLists = this.firstArr;
        if (newVal === '2') this.advertiseLists = this.secondArr;
      }
    },
    created() { this.advertiseLists = this.firstArr },
    methods:{
      editItem(item) {
        this.$router.push({
          name:'editAdvertise',
          query:{id:item.indexId,type:this.activeName,title:item.title}
        })
      }
    }
  }
</script>
